// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2524":"68682fcf","3392":"94e5cc53","6492":"68682fcf","6916":"68682fcf","7127":"94e5cc53","7327":"68682fcf"}[chunkId] + ".chunk.css";
};